/**
 * A central place for window.SpeechRecognition on all platforms.
 */

if (typeof window !== 'undefined') {
    window.SpeechRecognition ??= window.webkitSpeechRecognition;
}
